export default __webpack_public_path__ + "static/media/about-halu.84ae9e71.png";